import ValueGrid from "components/grid/value-grid";
import Block from "components/layout/block";
import { parse } from "lib/locale";
import { ListEntity } from "models/list-entity";
import { EntityCollection } from "models/list-user-entity-collection";
import { FunctionComponent, useEffect, useState } from "react";
import { sharedDoGetEntityCollections } from "services/shared/list-user-entity-collection";
import { useLocale } from "stores/hooks/locale";

interface SingleBlockProps {
  listUuid: string;
  listUserUuid: string;
  listEntity: ListEntity;
}

const SingleBlock: FunctionComponent<SingleBlockProps> = ({
  listUuid,
  listUserUuid,
  listEntity,
}) => {
  const locale = useLocale();
  const [entityCollection, toggleEntityCollection] = useState<
    EntityCollection | undefined
  >(undefined);

  useEffect(() => {
    const fetch = async () => {
      // get collections
      const entityCollections = await sharedDoGetEntityCollections(
        listUuid,
        listUserUuid,
        listEntity.uuid,
      );
      let ec: EntityCollection = entityCollections[0];
      if (!ec) {
        // fake one (if merged, create an endpoint that returns a new object but doesn't persist anything)
        ec = {
          list_entity_uuid: listEntity.uuid,
          list_user_uuid: listUserUuid,
          uuid: "",
          order: 1,
          created_at: "",
          updated_at: "",
          secret: false,
          entityCollectionValues: [],
        };
      }

      toggleEntityCollection(ec);
    };
    fetch();
  }, []);

  if (!entityCollection) {
    return null;
  }

  return (
    <Block title={parse(listEntity.name, locale)}>
      <ValueGrid
        listEntityFields={listEntity.listEntityFields || []}
        entityCollections={[{ ...entityCollection }]}
      />
    </Block>
  );
};

export default SingleBlock;
